import { useTranslation } from '@/lib/i18n/i18n.client';
import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';

import Button from '@/components/atoms/button';
import Heading from '@/components/atoms/heading';

import IconCheckmarkCircle from '~/svg/IconCheckmarkCircle.svg';

type ContactSalesFormSuccessProps = {
  onSubmit?: () => void;
  onClose?: () => void;
};

export function ContactSalesFormSuccess({
  onSubmit,
  onClose,
}: ContactSalesFormSuccessProps) {
  const { texts } = useTranslation();

  return (
    <div className='flex min-h-[650px] flex-col items-center justify-start'>
      <div className='text-neutral-N99 mb-12'>
        {currentLocaleConfig().logo()}
      </div>
      <div className='mb-6 flex items-center gap-3'>
        <IconCheckmarkCircle className='text-success-S99 max-h-7 min-h-7 min-w-7 max-w-7' />
        <Heading level='h2'>
          {texts.contact_sales.success.sent_successfully}
        </Heading>
      </div>
      <p className='mb-9'>{texts.contact_sales.success.message}</p>

      {onSubmit && (
        <Button classNames={{ root: 'w-full md:w-fit' }} onClick={onSubmit}>
          {texts.contact_sales.success.book_demo_call}
        </Button>
      )}
      {onClose && (
        <Button onClick={onClose} classNames={{ root: 'w-full md:w-fit' }}>
          {texts.contact_sales.success.close}
        </Button>
      )}
    </div>
  );
}
